import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../lib/motion";
import { BRANDS } from "../data";

export default function BrandPortfolio() {
  return (
    <section id="brands" className="bg-white py-24 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="max-w-[760px] mb-16">
          <Reveal><p className="overline text-[#B08D57] mb-6">The House</p></Reveal>
          <Reveal delay={0.1}>
            <h2 className="section-title font-display text-[#111] mb-6">Our Brand Portfolio</h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="font-body text-lg text-[#666] leading-relaxed">
              A curated house of Indian premium brands, created for global markets.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {BRANDS.map((b, i) => (
            <Reveal key={b.key} delay={(i % 2) * 0.1}>
              <Link
                to={`/brands/${b.key}`}
                data-testid={`brand-card-${b.key}`}
                className="group block relative overflow-hidden border border-[#E7E1D6] bg-[#F8F7F3] p-9 md:p-12 h-full transition-colors duration-500 hover:bg-[#111]"
              >
                <span
                  className="absolute top-0 left-0 h-1 w-full transition-all duration-500"
                  style={{ background: b.accent }}
                />
                <div className="flex items-start justify-between">
                  <span className="overline text-[11px]" style={{ color: b.accent }}>0{i + 1}</span>
                  <ArrowUpRight
                    className="text-[#999] group-hover:text-white transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1"
                    size={22}
                  />
                </div>
                <h3 className="font-display text-4xl md:text-5xl text-[#111] mt-8 mb-3 tracking-wide transition-colors duration-500 group-hover:text-white">
                  {b.name}
                </h3>
                <p className="font-display italic text-lg mb-6" style={{ color: b.accent }}>
                  {b.tagline}
                </p>
                <p className="font-body text-[15px] text-[#666] leading-relaxed max-w-[440px] transition-colors duration-500 group-hover:text-white/70">
                  {b.description}
                </p>
                <span className="inline-flex items-center gap-2 mt-8 font-head font-semibold text-sm text-[#111] transition-colors duration-500 group-hover:text-white">
                  Explore {b.name.charAt(0) + b.name.slice(1).toLowerCase()}
                  <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
